import { CheckIcon } from '@heroicons/react/24/outline';

interface ConfirmTickCardProps {
    checked: boolean;
    onChange: (checked: boolean) => void;
    label: string;
    detail?: string;
}

function ConfirmTickCard({ checked, onChange, label, detail }: ConfirmTickCardProps) {
    return (
        <label
            className={`flex items-start gap-3 px-4 py-3 rounded-xl border cursor-pointer transition-colors ${
                checked ? 'border-gray-800 bg-gray-50' : 'border-gray-200 bg-white hover:bg-gray-50'
            }`}
        >
            <input
                type="checkbox"
                checked={checked}
                onChange={(e) => onChange(e.target.checked)}
                className="sr-only peer"
            />
            <span
                aria-hidden="true"
                className={`mt-0.5 w-4 h-4 flex-shrink-0 rounded flex items-center justify-center border transition-colors peer-focus-visible:ring-2 peer-focus-visible:ring-gray-400 peer-focus-visible:ring-offset-1 ${
                    checked ? 'bg-gray-900 border-gray-900' : 'bg-white border-gray-300'
                }`}
            >
                {checked && <CheckIcon className="w-3 h-3 text-white" strokeWidth={3} />}
            </span>
            <span className="flex-1 min-w-0">
                <span className="block text-sm font-semibold text-gray-800">{label}</span>
                {detail && <span className="block text-xs text-gray-500 mt-0.5">{detail}</span>}
            </span>
        </label>
    );
}

export { ConfirmTickCard };
